/* SPRYNT 360 graden viewer */
(function () {
  if (customElements.get('sprynt-spin-360')) return;

  class SpryntSpin360 extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-spin-stage]');
      this.image = this.querySelector('[data-spin-image]');
      const dataEl = this.querySelector('[data-spin-frames]');
      if (!this.stage || !this.image || !dataEl) return;

      try {
        this.frames = JSON.parse(dataEl.textContent) || [];
      } catch (err) {
        this.frames = [];
      }
      if (this.frames.length < 2) return;

      this.index = 0;
      this.loaded = 0;
      this.preloading = false;
      this.dragging = false;
      this.hasInteracted = false;

      this.turns = parseFloat(this.dataset.turns) || 1;
      this.reverse = this.dataset.reverse === 'true';
      this.autoplay = this.dataset.autoplay === 'true';
      this.fps = parseInt(this.dataset.fps, 10) || 14;

      this.progress = this.querySelector('[data-spin-progress]');
      this.prevBtn = this.querySelector('[data-spin-prev]');
      this.nextBtn = this.querySelector('[data-spin-next]');

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.stage.addEventListener('pointerdown', this.onPointerDown);
      this.stage.addEventListener('pointermove', this.onPointerMove);
      this.stage.addEventListener('pointerup', this.onPointerUp);
      this.stage.addEventListener('pointercancel', this.onPointerUp);
      this.stage.addEventListener('keydown', this.onKeyDown);
      this.stage.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      this.bindHold(this.prevBtn, -1);
      this.bindHold(this.nextBtn, 1);

      this.observe();
    }

    disconnectedCallback() {
      this.stopAuto();
      this.holdStop();
    }

    /* ---------- laden ---------- */

    observe() {
      if (!('IntersectionObserver' in window)) {
        this.preload();
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.preload();
              io.disconnect();
            }
          });
        },
        { rootMargin: '300px' }
      );
      io.observe(this);
    }

    preload() {
      if (this.preloading) return;
      this.preloading = true;
      this.classList.add('is-loading');

      this.frames.forEach((src) => {
        const img = new Image();
        img.decoding = 'async';
        const done = () => {
          this.loaded += 1;
          const pct = Math.round((this.loaded / this.frames.length) * 100);
          if (this.progress) {
            this.progress.style.setProperty('--spin-progress', pct + '%');
          }
          if (this.loaded >= this.frames.length) this.onReady();
        };
        img.onload = done;
        img.onerror = done;
        img.src = src;
      });
    }

    onReady() {
      this.classList.remove('is-loading');
      this.classList.add('is-ready');
      if (this.autoplay && !this.hasInteracted) this.startAuto();
    }

    /* ---------- frames ---------- */

    setFrame(i) {
      const n = this.frames.length;
      this.index = ((i % n) + n) % n;
      this.image.src = this.frames[this.index];
    }

    step(dir) {
      this.setFrame(this.index + (this.reverse ? -dir : dir));
    }

    /* ---------- slepen en swipen ---------- */

    onPointerDown(e) {
      this.preload();
      this.markInteracted();
      this.dragging = true;
      this.startX = e.clientX;
      this.startIndex = this.index;
      this.stage.classList.add('is-dragging');
      try {
        this.stage.setPointerCapture(e.pointerId);
      } catch (err) {
        /* niets */
      }
    }

    onPointerMove(e) {
      if (!this.dragging) return;
      const width = this.stage.clientWidth || 1;
      const step = width / (this.frames.length * this.turns);
      let delta = (e.clientX - this.startX) / step;
      if (this.reverse) delta = -delta;
      this.setFrame(this.startIndex + Math.round(delta));
    }

    onPointerUp(e) {
      if (!this.dragging) return;
      this.dragging = false;
      this.stage.classList.remove('is-dragging');
      try {
        this.stage.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* niets */
      }
    }

    onKeyDown(e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.markInteracted();
        this.step(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.markInteracted();
        this.step(-1);
      }
    }

    /* ---------- knoppen ingedrukt houden ---------- */

    bindHold(button, dir) {
      if (!button) return;
      const start = (e) => {
        e.preventDefault();
        this.preload();
        this.markInteracted();
        this.step(dir);
        this.holdTimer = setTimeout(() => {
          this.holdInterval = setInterval(() => this.step(dir), 1000 / this.fps);
        }, 300);
      };
      const stop = () => this.holdStop();

      button.addEventListener('pointerdown', start);
      button.addEventListener('pointerup', stop);
      button.addEventListener('pointerleave', stop);
      button.addEventListener('pointercancel', stop);
    }

    holdStop() {
      if (this.holdTimer) clearTimeout(this.holdTimer);
      if (this.holdInterval) clearInterval(this.holdInterval);
      this.holdTimer = null;
      this.holdInterval = null;
    }

    /* ---------- automatisch draaien ---------- */

    startAuto() {
      this.stopAuto();
      this.autoTimer = setInterval(() => this.setFrame(this.index + 1), 1000 / this.fps);
    }

    stopAuto() {
      if (this.autoTimer) clearInterval(this.autoTimer);
      this.autoTimer = null;
    }

    markInteracted() {
      this.hasInteracted = true;
      this.stopAuto();
      this.classList.add('has-interacted');
    }
  }

  customElements.define('sprynt-spin-360', SpryntSpin360);
})();
